import React, { useState } from "react";
import Navber from "../../Components/Navber.jsx";
import "./Jayraj_transport.css";
import { FaBus, FaTrain, FaPlane, FaTaxi } from "react-icons/fa";

import FlightSearch from "./FlightSearch";
import BusSearch from "./BusSearch";
import TrainSearch from "./TrainSearch";
import CabSearch from "./CabSearch";

function Transport_page() {
  const [activeTab, setActiveTab] = useState("plane");

  return (
    <>
      <Navber />

      <section className="travel-hero">
        <div className="travel-container">

          {/* Tabs */}
          <div className="transport-tabs">
            {[
              { key: "bus", icon: <FaBus />, label: "Bus" },
              { key: "train", icon: <FaTrain />, label: "Train" },
              { key: "plane", icon: <FaPlane />, label: "Flights" },
              { key: "cab", icon: <FaTaxi />, label: "Cab" }
            ].map(tab => (
              <button
                key={tab.key}
                className={`transport-tab ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Booking Card */}
          <div className="booking-card fade-in">
            {activeTab === "plane" && <FlightSearch />}
            {activeTab === "bus" && <BusSearch />}
            {activeTab === "train" && <TrainSearch />}
            {activeTab === "cab" && <CabSearch />}
          </div>

        </div>
      </section>
    </>
  );
}

export default Transport_page;
